/**
 * Resolves Bootstrap 5 column span values for responsive breakpoints when
 * larger breakpoints are omitted: each inherits from the next-smaller one.
 *
 * xl ← lg ← md ← sm ← col
 */
export interface BootstrapColWidthsResolved {
  sm: string;
  md: string;
  lg: string;
  xl: string;
}

export function resolveBootstrapColWidths(
  col: string,
  sm: string | undefined,
  md: string | undefined,
  lg: string | undefined,
  xl: string | undefined
): BootstrapColWidthsResolved {
  const effSm = sm ?? col;
  const effMd = md ?? effSm;
  const effLg = lg ?? effMd;
  const effXl = xl ?? effLg;
  return { sm: effSm, md: effMd, lg: effLg, xl: effXl };
}
